import React from 'react';

import { Input01, Input02 } from './styles';

import { InputProps } from './interface';

const Input: React.FC<InputProps> = ({ mask, ...props }) => {
  if (mask) {
    return <Input02 mask={mask} {...props} />;
  }
  return <Input01 {...props} />;
};

export default Input;
